/// <reference types="vite-plugin-pwa/client" />
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import '@fontsource/manrope';
import 'material-symbols/outlined.css';
import { DataProvider } from './context/DataContext';
import { SyncProvider } from './context/SyncContext';
import { ToastProvider } from './context/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';

// --- PWA SERVICE WORKER BAŞLANGIÇ ---
import { registerSW } from 'virtual:pwa-register';

if ('serviceWorker' in navigator) {
  registerSW({ immediate: true });
}
// --- PWA SERVICE WORKER BİTİŞ ---

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <ToastProvider>
      <DataProvider>
        <SyncProvider>
          <App />
        </SyncProvider>
      </DataProvider>
    </ToastProvider>
  </ErrorBoundary>
);